/**
 * Formats a number as percentage.
 * Null/undefined/empty → blank; 0 → "0.00%".
 * @param {number|string|null|undefined} value - Number to format
 * @returns {string} Formatted percentage string
 */
const formatPercentage = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  return `${parseFloat(value).toFixed(2)}%`;
};

export default formatPercentage;
